var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 29.1668C7.176 29.1668 0.833374 22.8241 0.833374 15.0002C0.833374 7.17613 7.176 0.833496 15 0.833496C22.824 0.833496 29.1667 7.17613 29.1667 15.0002C29.1667 22.8241 22.824 29.1668 15 29.1668ZM13.5834 19.2502V22.0835H16.4167V19.2502H13.5834ZM16.4167 16.9199C18.4648 16.3103 19.9584 14.413 19.9584 12.1668C19.9584 9.42841 17.7385 7.2085 15 7.2085C12.5945 7.2085 10.5891 8.92152 10.1371 11.1942L12.9158 11.75C13.1096 10.776 13.9691 10.0418 15 10.0418C16.1736 10.0418 17.125 10.9932 17.125 12.1668C17.125 13.3404 16.1736 14.2918 15 14.2918C14.2176 14.2918 13.5834 14.9261 13.5834 15.7085V17.8335H16.4167V16.9199Z",
    fill: "#207DF7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaq);
export default __webpack_public_path__ + "static/media/faq.046cfa4e52620e0e1530a5037761570b.svg";
export { ForwardRef as ReactComponent };